import {
  BellOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@gds-react/icons";
import {
  Content,
  Description,
  IconWrapper,
  Title,
  Wrapper,
} from "./Toast.styles";

export type ToastVariant = "success" | "error" | "info";

interface Props {
  variant?: ToastVariant;
  title: string;
  description?: string;
}

const icons = {
  success: <CheckCircleOutlined />,
  error: <CloseCircleOutlined />,
  info: <BellOutlined />,
};

export default function Toast({ variant = "info", title, description }: Props) {
  return (
    <Wrapper>
      <IconWrapper $variant={variant}>{icons[variant]}</IconWrapper>
      <Content>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </Content>
    </Wrapper>
  );
}
